<template>
  <div >
    <div class="hour24-tit">
        <span>24小时预报</span>
        <div class="hour24-rise-down">
            <img src="../assets/sunup.png"  />
            <span>{{hour_rise}}</span>
            <img src="../assets/sunset.png" style="margin-left:12px;"/>
            <span>{{hour_down}}</span>
        </div>
    </div>
    <div class="scroll-hour" @scroll="scrollHour" v-if="forecastHourList&&hourTemperature&&hourTemperature.length>0">
      <div style="{minWidth: forecastHourList.length/2*116 + 'px'}">
        <div style="width:26px; position:absolute; top:0; left:0px; height:80px; ">
           <span :style="maxStyle">{{hourMaxTmp.toFixed(0)}}°</span>
           <span style="position:absolute; right:8px; bottom:8px; font-size:10px;" v-if="hourMaxTmp!=hourMinTmp">{{hourMinTmp.toFixed(0)}}°</span>
        </div>
        <div class="row row-rect" :style="rowStyle" v-if="forecastHourList&&forecastHourList.length>0">
          <svg-hour :type="type" :aqiHour="item" :cur="index==0||index==hourTemperature.length-1?1:2" :isCur="areaIndex==index" :isOk="index>0?true:false" v-for="(item, index) in hourTemperature" :key="index"></svg-hour>
          <div style="position:absolute; top:0; left:26px; width:100%; z-index:100; " >
            <svg-line :aqiHour="forecastHourList" :hourIndex="hourIndex" :hourLength="hourTemperature.length"></svg-line>
          </div>
          <div class="hour-icon-box" :style="iconStyle">
            <div :style="iconitemStyle(item)" v-for="(item, index) in hourIconList" :key="index">
              <img class="hour-icon" :src="item.icon" style="" />
            </div>
          </div>
        </div>
      </div>
      <div class="index-hour24-hour" :style="{width: forecastHourList.length/2*116 + 'px',  marginLeft: '12px', marginTop: '8px'}">
        <div class="hour-num" :class="[item.flag ? 'hour-item-now': '' ]"  v-for="(item, index) in forecastHourList" :key="index">
          <span>{{item.hour}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
var S = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 13, 14, 15, 16, 17, 18, 19, 20, 29, 30, 31, 32, 33, 34, 35, 36, 45, 46];
import SvgLine from './SvgLine';
import SvgHour from './SvgHour';
import BScroll from 'better-scroll';
export default {
  props: {
    hour_rise: String,
    hour_down: String,
    forecastHourList: Array,
    type: String,
    cdn: String
  },
  data() {
    return {
      hourMaxTmp: 0,
      hourMinTmp: 0,
      hourMaxTmpT: 0,
      hourTemperature: [
      ],
      hourIndex: 0,
      areaIndex: 0,
      hourIconList: {},
      realHourListNew: {}
    }
  },
  components:{
    SvgLine,
    SvgHour
  },
  created() {
    this.getHourTemperature()
  },
  mounted() {

  },
  computed: {
    iconitemStyle() {
      return function(item) {
        return {
          width: item.num*58 + 'px',
          display: 'block',
          float: 'left',
          height: '80px',
          position: 'relative'
        }
      }
    },
    iconStyle() {
      return {
        width: (this.forecastHourList.length/2*116) + 'px',
        left: '26px'
      }
    },
    maxStyle() {
      return {
        position: 'absolute',
        right: '8px',
        top: (160 - this.hourMaxTmpT - 16) / 2 + 'px',
        fontSize: '10px'
      }
    },
    rowStyle() {
      return {
        width: this.forecastHourList.length/2*116 + 'px',
        marginLeft: '25px',
        height: '80px',
        overflow:'hidden',
        display:'flex'
      }
    },
    rowStyleWidth() {
      return {
        width: this.forecastHourList.length/2*116 + 'px'
      }
    }
  },
  methods: {
    scrollHour(t) {
      var e = this, a = document.body.clientWidth,
      i = t.target,
      // s = i.deltaX,
      o = i.scrollLeft,
      n = i.scrollWidth;

      var r = this.forecastHourList.length, l = 0, c = o / (n - a), d = c * (r - 1), h = c * (this.hourTemperature.length - 1);

      d < 4 ? (d < .2 ? d = 0 : d += 1, d = parseInt(d)) : d = Math.round(d), d = d == r ? r - 1 : d,
        this.realHourListNew.forEach(function (t, a) {
          e.realHourListNew.length;
          var i = t.length;
          d >= t[0].oldIndex && d < t[0].oldIndex + i && (h = a);
        }), l = d; this.hourIndex != l && (this.hourIndex = l); h != this.areaIndex && (this.areaIndex = h);
    },
    getHourTemperature () {
      // 处理最大最小温度
      for (var e = this.forecastHourList, a = -50, i = 50, s = 0; s < e.length; s++) {
        e[s].oldIndex = s;
        var o = Number(e[s].tmp);
        o > a && (a = o), i > o && (i = o), e[s].x = 29 + 116 * s, e[s].y = o;
      }
      var n = a === i ? 1 : a - i, r = 160 / (a - i + 2 * n), l = e[0].icon, c = [];
      this.hourMaxTmp = a;
      this.hourMinTmp = i;
      this.hourMaxTmpT = n * r * 2;

      for (var d = [], h = 0; h < e.length; h++) {
        var f = e[h];
        f.y = (f.y - i + n) * r, f.index = h, f.icon != l ? (d.length > 0 && (c.push(d),
          d.icon = l), l = f.icon, (d = []).push(f), h == e.length - 1 && (c.push(d), d.icon = l)) : (0,
            d.push(f), h == e.length - 1 && (c.push(d), d.icon = l));
      }

      for (var g = [], u = 0; u < c.length; u++) {
        var p = c[u];
        if (p.length > 7) {
          var m = Math.floor(p.length / 6), w = null;
          if (m <= 1) (w = p.slice(0, 6)).icon = p.icon, g.push(w), (w = p.slice(6)).icon = p.icon,
            g.push(w); else for (var D = 0; D < m; D++) D == m - 1 ? (w = p.slice(6 * D)).icon = p.icon : (w = p.slice(6 * D, 6 * (D + 1))).icon = p.icon,
              g.push(w);
        } else g.push(p);
      }

      for (var S = [], v = document.body.clientWidth / 375, b = 0; b < g.length; b++) {
        var I = g[b], y = {};
        y.left = I[0].index * v * 116 / 2, y.right = I.length * v * 116 / 2 + y.left, y.icon = this.getWeatherIcon(Number(I.icon)),
          y.num = I.length, b == g.length - 1 ? y.leftL = (y.right - y.left) / 2 + y.left - 60 * v / 2 : y.leftL = (y.right - y.left) / 2 + y.left - 46 * v / 2,
          S.push(y);
      }
      var x = JSON.parse(JSON.stringify(g));

      this.hourIconList = S;
      this.realHourListNew =  x;


      if(g.length > 1){
        for (var T = 0; T < g.length; T++) 0 != T ? T != g.length - 1 ? (g[T].unshift(g[T - 1][g[T - 1].length - 2]),
        g[T].push(g[T + 1][0])) : g[T].unshift(g[T - 1][g[T - 1].length - 2]) : g[T].push(g[T + 1][0]);
        this.hourTemperature = g
      }
    },
    getWeatherIcon (t) {
      for (var e = this.cdn + "/1.png", a = 0; a < S.length; a++) if (S[a] === t) {
        e = this.cdn + "/" + t + ".png";
        break;
      }
      return e;
    },
  }
}
</script>
<style lang="stylus">
@import '../stylus/mixin.styl';
.hour24-tit
  padding 0 10px 0 17px
  color #fff
  display flex
  justify-content space-between
  align-items center
  border-bottom-1px(rgba(255,255,255,.2))
  img
    width 25px
    height 20px
  span
    font-size 15px
  .hour24-rise-down
    img
      display inline-block
      margin 0 3px
    span
      font-size 11px
      font-family:PingFangSC-Light;
      font-weight:300;
.scroll-hour {
  height: 110px;
  margin-left: 10px;
  position: relative;
  overflow-x: scroll;
  font-family:PingFangSC-Light;
  font-weight:300;
}

.hour-icon-box {
  position: absolute;
  opacity: 0.3;
  top: 0;
  left: 41px;
  width: 100%;
  height: 80px;
  border-bottom: 1px solid rgba(255,255,255,0.3);
}

.hour-icon {
    position: absolute;
    bottom: 2px;
    left: 50%;
    margin-left: -10px;
    width: 20px;
    height: 20px;
    transition: all 1s linear;
}

.index-hour24-hour {
  display: flex;
  overflow: hidden;
  margin-left: 41px;
  flex-direction: row;
  align-items: stretch;
  font-size:11px;
  font-family:PingFangSC-Light;
  font-weight:300;
  color:rgba(255,255,255,.7);
}

.index-hour24-hour .hour-num {
  flex: 1;
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
